import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { OnboardingHighlightWrapper } from '@sorare/core/src/components/onboarding/OnboardingHighlightWrapper';

import { useMarketplaceEvents } from 'lib/events';

import { InfoIconTutorial } from '../InfoIconTutorial';
import { MarketVideoDialog } from '../MarketVideoDialog';
import { NewNavDialog } from '../NewNavDialog';

type Props = { isOnboardingFlow?: boolean; isNewNavigation?: boolean };
export const MarketVideoTutorial = ({
  isOnboardingFlow = false,
  isNewNavigation = false,
}: Props) => {
  const [open, setOpen] = useState(isOnboardingFlow);
  const [searchParams, setSearchParams] = useSearchParams();
  const [showIconTutorial, setShowIconTutorial] = useState(false);
  const [sawDialog, setSawDialog] = useState(false);
  const [newNavDialogOpen, setNewNavDialogOpen] = useState(false);
  const track = useMarketplaceEvents();

  const onCloseDialog = () => {
    setOpen(false);
    if (isOnboardingFlow && !sawDialog) {
      if (isNewNavigation) {
        setNewNavDialogOpen(true);
      } else {
        setShowIconTutorial(true);
      }
    }
    setSawDialog(true);
  };

  return (
    <>
      <OnboardingHighlightWrapper
        wrap={isOnboardingFlow}
        highlightName="MarketInfoIcon"
      >
        <IconButton
          color="quaternary"
          small
          onClick={() => {
            track('Open Video Tutorial On Marketplace');
            setOpen(true);
          }}
          icon={faInfoCircle}
        />
      </OnboardingHighlightWrapper>
      <MarketVideoDialog
        data-testid="market-video-dialog"
        open={open}
        onClose={onCloseDialog}
        showOnboardingElements={isOnboardingFlow && !sawDialog}
      />
      <NewNavDialog
        open={newNavDialogOpen}
        onClose={() => {
          setNewNavDialogOpen(false);
          setShowIconTutorial(true);
        }}
      />
      {showIconTutorial && (
        <InfoIconTutorial
          onClose={() => {
            setShowIconTutorial(false);
            searchParams.delete('isOnboardingFlow');
            setSearchParams(searchParams);
          }}
        />
      )}
    </>
  );
};
